import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { CountdownBarItem } from '../../store/countdown-bar.store';
import { CountdownBarHeaderComponent } from '../countdown-bar-header/countdown-bar-header';

@Component({
  selector: 'bingo-countdown-bar-collapsed',
  imports: [CountdownBarHeaderComponent],
  templateUrl: './countdown-bar-collapsed.html',
  styleUrl: './countdown-bar-collapsed.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownBarCollapsedComponent {
  readonly item = input.required<CountdownBarItem | null>();
  readonly expand = output();
}
